import React from 'react';
import { observer } from 'mobx-react';

const Dropdown = ({ items, onSelect, value, size, className, id }) => {
	return (
		<select value={value} onChange={e => onSelect(e.target.value)} size={size} className={className} id={id}>
			{items.map(item => {
				return (
					<option key={item.value} value={item.value}>
						{item.label}
					</option>
				);
			})}
		</select>
	);
};

export default observer(Dropdown);



// WEBPACK FOOTER //
// ./src/themes/default/components/DropdownTemplate.jsx